import styled from 'styled-components';
import React from 'react';

export interface MarqueeProps {
  children: any;
  gap?: string;
  childWidth?: string;
  duration?: number;
  stopOnHover?: boolean;
  className?: string;
}

export function Marquee({
  gap,
  children,
  childWidth,
  duration,
  stopOnHover,
  className,
}: MarqueeProps) {
  return (
    <Wrapper gap={gap} stopOnHover={stopOnHover} className={className}>
      <Content gap={gap} childWidth={childWidth} duration={duration}>
        {children}
      </Content>
      <Content gap={gap} childWidth={childWidth} duration={duration}>
        {children}
      </Content>
    </Wrapper>
  );
}

const Wrapper = styled.div<MarqueeProps>`
  padding: 1rem;
  margin: -1rem;
  max-width: 100%;
  position: relative;
  display: flex;
  overflow: hidden;
  user-select: none;
  gap: ${(p: MarqueeProps) => p.gap || `2rem`};

  ${(p: MarqueeProps) =>
    p.stopOnHover === true
      ? `&&:hover {
    && > * {
      animation-play-state: paused;
    }
  }`
      : ``}

  mask-image: linear-gradient(
    var(--mask-direction, to right),
    hsl(0 0% 0% / 0),
    hsl(0 0% 0% / 1) 5%,
    hsl(0 0% 0% / 1) 95%,
    hsl(0 0% 0% / 0)
  );
`;

const Content = styled.div<MarqueeProps>`
  flex-shrink: 0;
  display: flex;
  justify-content: space-around;
  gap: ${(p: MarqueeProps) => p.gap || `2rem`};
  min-width: 100%;

  animation: scroll ${(p: MarqueeProps) => p.duration || 10}s linear infinite;

  @keyframes scroll {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(
        calc(-100% - ${(p: MarqueeProps) => p.gap || `2rem`})
      );
    }
  }

  && > * {
    width: ${(p: MarqueeProps) => p.childWidth || `fit-content`};
  }
`;
